import script from "./DashboardV2Mixin.vue?vue&type=script&lang=js"
export * from "./DashboardV2Mixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__